import AccountProfile from "../views/AccountProfile";
import ChangePassCode from "../views/Auth/Changepasscode/index.js";
import ChangenewPassCode from "../views/Auth/Changepasscode/NewPasscode.js";
import ConfirmVerification from "../views/Auth/confirmVerification";
import CreateNewPasscode from "../views/Auth/createNewPasscode";
import ForgetPasscodeNumber from "../views/Auth/forgetPasscodeNumber";
import ForgetPin from "../views/Auth/forgetPin";
import Login from "../views/Auth/Login";
import SetPassCode from "../views/Auth/setPassCode";
import SignUp from "../views/Auth/signUp";
import CartPreviewPage from "../views/cart-preview/CartPreviewPage";
//import ServicePage from "../views/CommonStaticPages/ScrollTrackingContentsTable";
import CancellationAndRefundPolicy from "../views/CommonStaticPages/CancellationAndRefundPolicy";
import ContactPage from "../views/CommonStaticPages/ContactPage";
import DeliveryPolicy from "../views/CommonStaticPages/DeliveryPolicy";
import FAQs from "../views/CommonStaticPages/FAQs";
import PrivacyPolicy from "../views/CommonStaticPages/PrivacyPolicy";
import ServicePage from "../views/CommonStaticPages/ServicePage";
import TermsAndConditions from "../views/CommonStaticPages/TermsAndConditions";
import LabPackageComparePrice from "../views/Lab-Packages/LabPackageComparePrice";
import LabPackageComparePriceDmp from "../views/Lab-Packages/LabPackageComparePriceDmp";
import Landing from "../views/Landing";
import PopularTest from "../views/PopularTest";
import PopularPackages from "../views/PopularPackages";
import Checkout from "../views/PopularTest/Checkout";
import ComparePrice from "../views/PopularTest/ComparePrice";
import ShoppingCart from "../views/PopularTest/ShoppingCart";
import RecommendedTestPage from "../views/recommended-tests/RecommendedTestPage";
import SearchResultPage from "../views/search-result/SearchResultPage";
import Header from '../components/Header/Header';

const IndexRoutes = [
  { path: "/", component: Landing },
  { path: "/populartest", component: PopularTest },
  { path: "/popularpackages", component: PopularPackages },
  { path: "/compareprice", component: ComparePrice },
  { path: "/lab-package-compareprice/:id", component: LabPackageComparePrice },
  {
    path: "/lab-package-compareprices/:id",
    component: LabPackageComparePriceDmp,
  },

  { path: "/login", component: Login },
  { path: "/signup", component: SignUp },
  { path: "/setPassCode", component: SetPassCode },
  { path: "/confirmVerification", component: ConfirmVerification },
  { path: "/forgotPassword", component: ForgetPasscodeNumber },
  { path: "/forgetPin", component: ForgetPin },
  { path: "/createNewPasscode", component: CreateNewPasscode },
  { path: "/shoppingCart", component: ShoppingCart },
  { path: "/checkout", component: Checkout },
  { path: "/accountProfile", component: AccountProfile },
  { path: "/recommended-tests/:id", component: RecommendedTestPage },
  { path: "/search-results", component: SearchResultPage },

  // { path: "/addRecipient", component: CartPreviewPage },
  // { path: "/cart-preview", component: CartPreviewPage },
  { path: "/cart-update", component: CartPreviewPage },
  { path: "/faq", component: FAQs },
  { path: "/terms", component: TermsAndConditions },
  { path: "/contactus", component: ContactPage },
  { path: "/deliveryPage", component: DeliveryPolicy },
  { path: "/privacyPolicy", component: PrivacyPolicy },
  { path: "/servicePage", component: ServicePage },
  { path: "/cancellationRefundPolicy", component: CancellationAndRefundPolicy },
  { path: "/changePasscode", component: ChangePassCode },
  { path: "/NewPasscode", component: ChangenewPassCode },
  { path: "/Header", component: Header },
];

export default IndexRoutes;
